<!-- Modals -->
<app-deprecated-modal-form
    #applyTasksModal
    [form]="applyTasksForm"
    label="employees.employee-tasks.apply"
    (save)="onApplyTaskTemplates(applyTasksForm.getSelectedTaskTemplates())"
    (cancel)="onCancel()"
    headerText="{{ 'employees.employee-tasks.applyTaskTemplate' | appTranslate }}"
>
    <app-apply-tasks
        #applyTasksForm
        [employee]="employee"
        [tasks]="tasks"
        [generalTaskTemplates]="generalTaskTemplates"
        [autoMatchedTaskTemplates]="autoMatchedTaskTemplates"
        [otherTaskTemplates]="otherTaskTemplates"
    ></app-apply-tasks>
</app-deprecated-modal-form>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <div class="header">
        <app-employee-header [employee]="employee" (isLoading)="isLoading = $event">
            <div class="buttons">
                <ui-button (click)="addNewTask()" type="link"
                    >{{ 'employees.employee-tasks.createNewTask' | appTranslate }}
                </ui-button>
                <ui-button *ngIf="showApplyTaskButton" (click)="showApplyTasksModal()" type="primary"
                    >{{ 'employees.employee-tasks.applyTaskTemplate' | appTranslate }}
                </ui-button>
            </div>
        </app-employee-header>
    </div>

    <div class="ui layout">
        <!-- Employee Card -->
        <div class="sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>

        <div class="content">
            <!--Tasks-->
            <div class="ui segment tasks" [class.loading]="isLoadingTasks">
                <ng-container>
                    <div class="tasks-header">
                        <app-segment-header [title]="segmentTitle"> </app-segment-header>
                        <!-- Tasks Filter Dropdown -->
                        <mat-form-field class="task-filter-dropdown">
                            <mat-select
                                name="filterTasks"
                                [value]="taskFilterType"
                                (selectionChange)="onToggleTaskFilter($event.value)"
                            >
                                <mat-option value="All Tasks">{{
                                    'employees.employee-tasks.allTasks' | appTranslate
                                }}</mat-option>
                                <mat-option value="Assigned to Self">{{
                                    'employees.employee-tasks.assignedToEmployeefirstName'
                                        | translate
                                            : {
                                                  firstName: employee.firstName,
                                              }
                                }}</mat-option>
                                <mat-option value="Created for Self"
                                    >{{
                                        'employees.employee-tasks.createdForEmployeefirstName'
                                            | translate
                                                : {
                                                      firstName: employee.firstName,
                                                  }
                                    }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!-- Content -->
                    <ng-container *ngIf="tasks?.length; else emptyTasksTemplate">
                        <div class="tasks-container" #tasksContainer>
                            <!-- Task Checklist-->
                            <app-task-checklist
                                #taskChecklist
                                [employee]="employee"
                                [tasks]="tasks"
                                (updateTasks)="updateTasks()"
                                (onScroll)="onScrollTasksList()"
                                (deleted)="onDelete()"
                                (reminded)="onReminded()"
                            ></app-task-checklist>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-template #emptyTasksTemplate>
                    <div class="empty-state">
                        <h2 *ngIf="taskFilterType === 'All Tasks'" class="ui centered header">
                            {{
                                'employees.employee-tasks.thereAreNoTasksCreatedForOrAssignedToEmployeefirstName'
                                    | translate: { firstName: employee.firstName }
                            }}
                        </h2>
                        <h2 *ngIf="taskFilterType === 'Assigned to Self'" class="ui centered header">
                            {{
                                'employees.employee-tasks.thereAreNoTasksAssignedToEmployeefirstName'
                                    | translate
                                        : {
                                              firstName: employee.firstName,
                                          }
                            }}
                        </h2>
                        <h2 *ngIf="taskFilterType === 'Created for Self'" class="ui centered header">
                            {{
                                'employees.employee-tasks.thereAreNoTasksCreatedForEmployeefirstName'
                                    | translate
                                        : {
                                              firstName: employee.firstName,
                                          }
                            }}
                        </h2>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
